import { sellerInitialState } from './seller.state';
import { SellerActionsUnion, SellerActionTypes } from './seller.actions';

export function sellerReducer(state = sellerInitialState, action: SellerActionsUnion) {
  switch (action.type) {
    case SellerActionTypes.LOAD_SELLER:
      return {...state, loading: true};
    case SellerActionTypes.LOAD_SELLER_SUCCESS:
      return {...state, loading: false, payload: action.payload.seller};
    case SellerActionTypes.LOAD_SELLER_FAILURE:
      return {...state, loading: false, error: action.payload.error};
    default:
      return state;
  }
}
